<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("smtp.text1") }}</h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-3>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title>
                <v-layout row wrap>
                  <v-flex xs10 lg3 ml-3>
                    <v-btn color="#077893" outlined to="/email-smtp-add">
                      <v-icon class="mr-1">mdi-plus</v-icon>
                      {{ $t("smtp.text3") }}
                    </v-btn>
                    <br />
                    <br />
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs6 lg4>
                    <v-text-field
                      color="#077893"
                      append-icon="mdi-magnify"
                      v-model="Search"
                      outlined
                      clearable
                      :label="$t('consentlist.search')"
                      type="text"
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text class="mt-n4">
                <v-card outlined>
                  <v-data-table
                    class="ellipsis"
                    :headers="headers"
                    :items="ItemPolicy"
                    :search="Search"
                    hide-default-footer
                    :page.sync="Page"
                    @page-count="PageCount = $event"
                    :items-per-page="ItemPerPage"
                  >
                    <template v-slot:[`item.UpdatdeBy`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.UpdatdeBy }}
                      </div>
                      <div v-else>
                        {{ item.UpdatdeByEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.UpdatdeAt`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.UpdatdeAt }}
                      </div>
                      <div v-else>
                        {{ item.UpdatdeAtEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.Status`]="{ item }">
                      <center>
                        <v-switch
                          small
                          @change="Fn_ChangeStatus(item)"
                          color="green"
                          v-model="item.Status"
                          inset
                        ></v-switch>
                      </center>
                    </template>
                    <template v-slot:[`item.CustomSmtp`]="{ item }">
                      <v-chip
                        small
                        dark
                        color="green"
                        v-if="item.CustomSmtp === false"
                        >Mail Server INET</v-chip
                      >
                      <v-chip
                        small
                        dark
                        color="info"
                        v-else-if="item.CustomSmtp === true"
                        >Mail Server User</v-chip
                      >
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-menu offset-y>
                        <template v-slot:activator="{ attrs, on }">
                          <v-btn
                            dark
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="mx-2"
                            fab
                            color="#077893"
                          >
                            <v-icon dark size="20">
                              mdi-format-list-bulleted-square
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list v-for="(list, i) in itemsAction" :key="i" dense>
                          <v-list-item
                            @click="fn_checkActionType(list.service, item)"
                            link
                          >
                            <v-list-item-icon class="mr-3">
                              <v-icon :color="list.color"
                                >{{ list.icon }}
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title
                              v-if="$t('default') === 'th'"
                              :inner-text.prop="list.text"
                              style="font-size: 14px"
                            ></v-list-item-title>
                            <v-list-item-title
                              v-else
                              :inner-text.prop="list.text2"
                              style="font-size: 14px"
                            ></v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                </v-card>

                <v-pagination
                  :total-visible="7"
                  class="pt-2 pb-2"
                  circle
                  color="#077893"
                  v-model="Page"
                  :length="PageCount"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                >
                </v-pagination>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <DialogDelete
        :show="DialogDelete"
        :_item="ItemDelete"
        @closeDialogDelete="DialogDelete = false"
        @reData="Fn_GetDataSmtpEmail()"
      />
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import DialogDelete from "@/components/dialog/DialogSmtpEmailDelete.vue";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogDelete, OverlaySearch },
  data: function () {
    return {
      Search: "",
      Page: 1,
      PageCount: 0,
      ItemPerPage: 10,
      ItemPolicy: [],
      ItemDelete: [],
      DialogDelete: false,
      loadingDownloadData: false,
      itemsAction: [
        {
          icon: "mdi-pencil",
          text: "แก้ไขข้อมูล",
          text2: "Edit",
          color: "orange",
          service: "Edit",
        },
        {
          icon: "mdi-trash-can",
          text: "ลบข้อมูล",
          text2: "Delete",
          color: "red",
          service: "Del",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },

    headers() {
      return [
        {
          text: this.$i18n.t("dashboard.num"),
          value: "no",
          sortable: false,
          align: "center",
        },
        {
          text: "ชื่อผู้ส่ง",
          value: "SenderDisplayName",
          align: "center",
          sortable: false,
        },
        {
          text: "อีเมลแอดเดรสผู้ส่ง",
          value: "SenderEmailAddress",
          align: "center",
          sortable: false,
        },
        {
          text: "Smtp Host",
          align: "center",
          value: "SmtpHost",
          sortable: false,
        },
        {
          text: "Smtp Port",
          align: "center",
          value: "SmtpPort",
          sortable: false,
        },
        {
          text: this.$i18n.t("dashboard.cby"),
          value: "UpdatdeBy",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("policyForm.led"),
          value: "UpdatdeAt",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("smtp.text4"),
          align: "center",
          value: "Status",
          sortable: false,
        },
        {
          text: "รูปแบบการเชื่อมต่อ",
          align: "center",
          value: "CustomSmtp",
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.choice"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  mounted() {
    this.Fn_GetDataSmtpEmail();
  },
  methods: {
    async Fn_GetDataSmtpEmail() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "config-notify/GetDetailConfigEmail",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
            var startPage = this.Page * this.ItemPerPage - this.ItemPerPage + 1;
            var nextPage = startPage + this.ItemPolicy.length;
            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemPolicy) {
              this.ItemPolicy[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_ChangeStatus(val) {
      var payload = {
        ConfigEmailId: val.ConfigEmailId,
        BusinessId: val.BusinessId,
        AccountId: this.$cookies.get("OneAccountId"),
        Status: val.Status,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "config-notify/SwitchHostEmail",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            Toast.fire({
              icon: "success",
              title: response.data.Message,
            });
          } else {
            val.Status = false;
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          val.Status = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Update(item) {
      this.$router.push("/email-smtp-update");
      this.$store.dispatch("SET_DATA_SMTP_EMAIL", item);
    },
    Fn_Delete(item) {
      this.DialogDelete = true;
      this.ItemDelete = item;
    },
    fn_checkActionType(val, item) {
      if (val == "Edit") {
        this.Fn_Update(item);
      } else if (val == "Del") {
        this.Fn_Delete(item);
      }
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
